class KlaviyoSubscribe extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initForm();
  }

  initForm() {
    const form = this.querySelector("#klaviyo-subscribe-form");
    const messageDiv = this.querySelector("#klaviyo-form-message-subscribe");
    const errorMessage = messageDiv.querySelector(
      ".error-message .banner__content"
    );

    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      const email = form.elements["email"].value.trim();
      const listId = form.elements["g"].value;

      messageDiv.classList.remove("success", "error");

      const formData = new URLSearchParams();
      formData.append("g", listId);
      formData.append("email", email);

      try {
        const response = await fetch(
          "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Cache-Control": "no-cache",
            },
            body: formData.toString(),
          }
        );

        const data = await response.json();

        if (data.success) {
          messageDiv.classList.add("success");
          form.reset();
        } else {
          throw new Error(data.error || "Error");
        }
      } catch (error) {
        errorMessage.textContent = error.message;
        messageDiv.classList.add("error");
      }
    });
  }
}

customElements.define("klaviyo-subscribe", KlaviyoSubscribe);
